var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SitecoreLink',{staticClass:"footer__column-link",attrs:{"iconField":this.fields.LinkIcon,"linkField":this.fields.Link,"editable":false}})}
var staticRenderFns = []

export { render, staticRenderFns }